import React, { useEffect } from "react";
import { makeRequest } from "./util";
import * as Sentry from "@sentry/browser";
import { Autocomplete } from "@material-ui/lab";
import { Chip, TextField } from "@material-ui/core";

interface AutocompleteMultiSelectProps {
  propName;
  value;
  onChange;
}

function AutocompleteMultiSelectField({
  propName,
  value,
  onChange,
  ...rest
}: AutocompleteMultiSelectProps) {
  const [options, setOptions] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const visibleOptions = open ? options : [];

  useEffect(() => {
    if (!propName) {
      setOptions([]);
      return;
    }
  }, [propName]);

  function onInputChange(event, inputValue) {
    makeRequest("autocomplete_prop", {
      prop_name: propName,
      prop_value: inputValue,
    })
      .then((response: any) => {
        setOptions(response.data);
      })
      .catch((error) => {
        console.log(error);
        Sentry.captureException(error);
      });
  }

  return (
    <Autocomplete
      multiple
      id="MultiSelectValue"
      value={value}
      options={visibleOptions}
      defaultValue={[]}
      freeSolo
      onChange={(event, currentItem) => {
        onChange(currentItem);
      }}
      // handles autocomplete list
      onInputChange={onInputChange}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      renderTags={(value: string[], getTagProps) =>
        value.map((option: string, index: number) => (
          <Chip variant="outlined" label={option} {...getTagProps({ index })} />
        ))
      }
      renderInput={(params) => <TextField {...params} {...rest} />}
    />
  );
}

export default AutocompleteMultiSelectField;
